<template>
	<div>
		<div class="rappel_contact">
			<div class="content">
				<div style="margin-top: -10px;" class="bloc-info col-4">
				<p style="font-size: 14px;text-transform: initial;">
					<i class="fa fa-map-marker fa-2x"></i><br><br>
					1, place Francis Chirat, 13002 Marseille
				</p>
			
				</div>
				<div style="margin-top: -10px;" class="bloc-info  col-4">
					<p style="font-size: 14px;text-transform: initial;">
						<i class="fa fa-phone fa-2x"></i><br><br>
						06 15 03 76 17
					</p>
				</div><div style="margin-top: -10px;" class="bloc-info  col-4">
					<p style="font-size: 14px;text-transform: initial;">
						<i class="fa fa-envelope-o fa-2x"></i><br><br>
						<a href="mailto:contact@vinzi-studio.com">contact@vinzi-studio.com</a>
					</p>
				</div>
				<div  style="text-align: center;" class="bloc-info  col-4">
					<a href="https://www.facebook.com/vinzistudio/" class="social" target="_blank">
						<img src="../assets/picto_fb.jpg" alt="">
					</a>
					<a href="https://vimeo.com/vinzistudio" class="social" target="_blank">
						<img src="../assets/picto_vimeo.jpg" alt="">
					</a>
				</div>
			</div>
		</div>

		<div class="footer">
			<a class="cp" v-on:click="OpenCloseMentions">Mentions Légales</a>
			&nbsp;&nbsp;|&nbsp;&nbsp;
			<a target="_blank" href="http://fournier-yoan-web.fr">Réalisation : Fournier Yoan Web</a>
		</div>

		<div class="panel-bottom" id="mentions">
			<div class="content">
				<div class="bloc-info col-3">
					<h3>Propriétaire du site</h3>
					<p> Vincent Evrard (Vinzi Studio) <br>
					1, place Francis Chirat <br>
					13002 Marseille</p>
				</div>
				<div class="bloc-info  col-3">
					<h3>Hébergement du site</h3>
					<p> Gestion par Vincent Evrard (Vinzi Studio) <br>
						1 place Françis Chirat <br>
						13002 Marseille 
						contact@vinzi-studio.com 
						sur serveur OVH pro	</p>
				</div>
				<div class="bloc-info col-3">
					<h3>Création du site</h3>
					<p>Graphisme : <br><a href="http://r-creativ.com/">R-créativ'</a></p>
					<br>
					<p>Intégration / développement :  <br><a href="http://fournier-yoan-web.fr/">Fournier Yoan Web</a></p>
				</div>
				<br><br> <br>
				<p style="font-weight:100; font-size: 14px;text-align:left">
					Conformément aux dispositions de la loi du n°78-17 du 6 janvier 1978 « informatique et liberté », les utilisateurs du site disposent d'un droit d'accès, de rectification et d'opposition sur les données nominatives les concernant. 
					Ce site vinzi-studio.com est la propriété de la société Vinzi Studio. <br>
					Toute reproduction d'éléments publiés sur ce site (textes, photos, éléments graphiques…) est formellement interdite sans autorisation préalable. Le non-respect de cette interdiction pourra entraîner des poursuites. 
					<br>
					© Vinzi Studio 2018 - Tous droits réservés
				</p>
			</div>
		</div>
		<div class="close-footer" v-on:click="ClosePanelBottom"></div>
	</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Footer',
  methods: {
  	ClosePanelBottom() {
  		if ($('#mentions').css('bottom') == "0px") {
  			
  			$('#mentions').css('bottom', "-100%");
  			$('.close-footer').css('top', "-100%");

  		}
  	},
  	OpenCloseMentions() {
  		if ($('#mentions').css('bottom') != "0px") {
  			$('.panel-bottom-menu').css('bottom', "-100%");

  			$('#mentions').css('bottom', 0);
  			$('.close-footer').css('top', 0);

  		}else {
  			$('#mentions').css('bottom', "-100%");
  			$('.close-footer').css('top', "-100%");

  		}
  	}
  }
}
</script>

<style scoped>
.rappel_contact {
	text-align: center;
	background: #000;
	padding: 30px 20px;
	color: #fff;
}
.social:hover { opacity: 0.7; }

.footer {
	height: 15px;
	padding: 5px 0;
	width: 100%;
	background: rgba(0,0,0,1);
	z-index: 110;
	font-size: 12px;
	text-align: center;
	position: relative;
	color: #fff;
}
 
.panel-bottom {
  position: fixed;
  bottom: 0;
  bottom: -100%;
  height: 44%;
  overflow-y: auto;
  background: rgba(0,0,0,0.7);
  color: #fff;
  text-align: center;
  width: 100%;
  padding: 3% 0;
  transition-duration: .5s;
  z-index: 99;

}

.header {
	text-align: center;
	padding: 10% 0 10%;
}

.content {
	width: 100%;
	max-width: 1170px;
	margin: auto;
	text-align: center;
}

.bloc-info.col-3 {

	width: 23%;
	margin: auto 1%;
	display: inline-block;
	text-align: center;

}
.bloc-info.col-4 {

	width: 19%;
	margin: auto .5%;
	display: inline-block;
	text-align: center;

}

.bloc-info  {
	display: block;
	margin-bottom: 30px;
}

.bloc-info img  {
	display: inline-block;
}
.bloc-info h3:after {
	content: "";
	display: block;
	width: 100px;
	height: 2px;
	background: #fff;
	margin: 15px auto;

}
.bloc-info h3 {
	font-weight: 100;
	text-transform: uppercase;
	margin: 20px 0 0 20px;
	display: inline-block;
}

#contact h3 {
	text-transform: initial;
}
 
.cp { cursor: pointer; }


.close-footer {
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  height: 50%;
  z-index: 88;
  top: -50%;
}
.decal_picto {
	margin: -10px 0 0 -60px;
}
@media screen and (max-width: 640px) { 

  .panel-right-menu img {
  	display: block;
	margin: auto;
  }

.bloc-info.col-3 {

	width: 98%;
	margin: auto 1%;
	display: inline-block;
	text-align: left;

}
.bloc-info.col-4 {

	width: 98%;
	margin: 30px 1%;
	display: inline-block;

}

}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue